import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import { useState } from "react";
import { ProjectCard } from "./ProjectCard";

import { graphicsProjects } from "../data/projectData";
import { webProjects } from "../data/projectData";
import { mobileProjects } from "../data/projectData";

export const Projects = () => {
  const [tabKey, setTabKey] = useState("first");

  const entries = {
    first: "Graphics",
    second: "Web App",
    third: "Mobile App",
  };

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col>
            <div className="d-flex align-items-center justify-content-center">
              <h3 className="tagline w-100">{entries[tabKey]} Projects</h3>
            </div>
            <Tab.Container
              id="projects-tab"
              activeKey={tabKey}
              onSelect={(k) => setTabKey(k)}
            >
              <Nav
                variant="pills"
                className="nav-pills mb-5 justify-content-center align-items-center"
                id="pills-tab"
              >
                <Nav.Item>
                  <Nav.Link eventKey="first">Graphics</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Web</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Mobile</Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Row>
                    {graphicsProjects.map((project, idx) => {
                      return (
                        <ProjectCard key={idx} {...project} fixed="200px" />
                      );
                    })}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Row>
                    {webProjects.map((project, idx) => {
                      return (
                        <ProjectCard key={idx} {...project} fixed="200px" />
                      );
                    })}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <Row>
                    {mobileProjects.map((project, idx) => {
                      return <ProjectCard key={idx} {...project} />;
                    })}
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
